/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, filter, includes, isEqual } from 'lodash';
import uuid from 'uuid/v1';
import { Table, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import TablePagination from '../TablePagination';
import Loading from '../Loading';
import BlankState from '../BlankState';
import { isAnnotationsLayer, isAnnotationsRealTime } from '../../../api/Layers/layer-operations';

const NAV_BAR_HEIGHT = 56;
const HEADER_HEIGHT = 49; // When it is all in the same line
const PAGINATION_HEIGHT = 45;
const CELL_HEIGHT = 35;
const BAD_URL = ['<!DOCTYPE html>', '<?xml version="1.0" ?>'];
const COMING_SOON = 'ComingSoon';
const DESCENDENT = 'desc';

export const getPopupAnnotations = properties => {
  let popup = `<p style="word-wrap: break-word; margin: 0;width: 30vw;"></p><hr>`;
  properties.map(item => {
    if (item.elementType === 'icon') {
      if (!isEmpty(item.caption)) {
        popup += `
        <div class="line-container">
          <div class="single-line" style="max-width: 30vw; word-wrap: break-word; margin-bottom: 0.5vh;">
            <p style="word-wrap: break-word; margin: 0;min-width: 10vw;"><h6><b>${item.caption}</b></h6></p>
            <img src=${item.value} alt="Descripción de la imagen" style="max-width: 30vw; height: auto">
          </div>
        </div>
      `;
      } else {
        popup += `
        <div class="line-container">
          <div class="single-line" style="max-width: 30vw; word-wrap: break-word; margin-bottom: 0.5vh;">
            <img src=${item.value} alt="Descripción de la imagen" style="max-width: 30vw; height: auto">
          </div>
        </div>
      `;
      }
    } else if (item.elementType === 'iframe') {
      popup += `
                <div class="line-container">
                  <div class="single-line" style="max-width: 30vw; word-wrap: break-word; margin-bottom: 0.5vh;">
                    <iframe src=${item.value} height="400" width="800" name="demo"></iframe>
                  </div>
                </div>
              `;
    } else if (item.elementType === 'image') {
      if (!isEmpty(item.value)) {
        if (!isEmpty(item.caption)) {
          popup += `
            <div class="line-container">
              <div class="single-line" style="max-width: 30vw; word-wrap: break-word; margin-bottom: 0.5vh;">
                <p style="word-wrap: break-word; margin: 0;min-width: 10vw;"><h6><b>${item.caption}</b></h6></p>
                <img src=${item.value} alt="Descripción de la imagen" style="max-width: 30vw; height: auto">
              </div>
            </div>
          `;
        } else {
          popup += `
            <div class="line-container">
              <div class="single-line" style="max-width: 30vw; word-wrap: break-word; margin-bottom: 0.5vh;">
                <img src=${item.value} alt="Descripción de la imagen" style="max-width: 30vw; height: auto">
              </div>
            </div>
          `;
        }
      }
    } else if (
      item.elementType === 'textarea' ||
      (item.elementType === 'input' && item.dataType === 'text')
    ) {
      if (!isEmpty(item.value)) {
        popup += `
        <div class="line-container">
          <div class="single-line" style="max-width: 30vw; word-wrap: break-word; margin-bottom: 0.5vh;">
            <p style="max-width: 30vw; word-wrap: break-word;"><h6><b>${item.value}</b></h6></p><hr>
          </div>
        </div>
      `;
      }
    } else if (item.elementType === 'video') {
      const obtenerVideoIdDesdeUrl = url => {
        const match = url.match(
          // eslint-disable-next-line no-useless-escape
          /(?:\?v=|&v=|youtu\.be\/|\/embed\/|\/v\/|\/e\/|youtu\.be\/|\/c\/|\/u\/|\/user\/\w+\/|embed\/|user\/\w+\/videos\/|\/v\/|\/R\/|\/C\/|\/E\/|\/G\/|\/H\/|\/J\/|\/K\/|\/L\/|\/N\/|\/P\/|\/Q\/|\/S\/|\/U\/|\/V\/|\/W\/|\/Y\/|\/hq\/|\/hqdefault\/|\/maxresdefault\/|\/thumbnail\/|\/1.jpg)([^#\&\?]*).*/
        );
        return match && match[1].length === 11 ? match[1] : null;
      };

      const obtenerSitioDesdeUrl = url => {
        const match = url.match(/^(?:https?:\/\/)?(?:www\.)?([a-z0-9-]+)\./i);
        return match ? match[1].toLowerCase() : null;
      };

      const agregarEmbed = url => {
        if (url.includes('/embed/')) {
          return url;
        }
        const sitio = obtenerSitioDesdeUrl(url);

        if (sitio === 'youtube' || sitio === 'youtu') {
          const videoId = obtenerVideoIdDesdeUrl(url);
          if (videoId) {
            return `https://www.youtube.com/embed/${videoId}`;
          }
        }
        return url;
      };

      if (!isEmpty(item.caption) && !isEmpty(item.value)) {
        const videoURL = agregarEmbed(item.value);
        popup += `
        <div class="line-container">
          <div class="single-line" style="max-width: 30vw; word-wrap: break-word; margin-bottom: 0.5vh;">
            <p style="word-wrap: break-word; margin: 0;min-width: 10vw;"><h6><b>${item.caption}</b></h6></p>
            <iframe width="100%" height="315" src=${videoURL} frameborder="0" style="max-width: 30vw"></iframe>
          </div>
        </div>
      `;
      } else if (!isEmpty(item.value)) {
        const videoURL = agregarEmbed(item.value);
        popup += `
        <div class="line-container">
          <div class="single-line" style="max-width: 30vw; word-wrap: break-word; margin-bottom: 0.5vh;">
            <iframe width="100%" height="315" src=${videoURL} frameborder="0" style="max-width: 30vw"></iframe>
          </div>
        </div>
      `;
      }
    }
    return popup;
  });

  return popup;
};

class ThematicLayerTable extends Component {
  state = {
    currentPage: 1
  };

  changePage = pageNumber => {
    this.setState({ currentPage: pageNumber });
  };

  render() {
    const {
      loading,
      tableBody,
      tableTitle,
      layerSubtype,
      isShared,
      height,
      changeSortIndex,
      sortIndex,
      verHtml,
      layer
    } = this.props;
    const { currentPage } = this.state;

    if (loading) {
      return <Loading />;
    }

    const verticalHeight = isShared ? CELL_HEIGHT : NAV_BAR_HEIGHT + HEADER_HEIGHT + CELL_HEIGHT;

    let itemsPerPage = Math.floor((height - verticalHeight - PAGINATION_HEIGHT) / CELL_HEIGHT);

    if (itemsPerPage < 1) itemsPerPage = 1;

    const skip = currentPage * itemsPerPage - itemsPerPage;
    const totalCount = tableBody.length;
    const pageBody = filter(
      tableBody,
      (tableRow, index) => index >= skip && index < skip + itemsPerPage
    );
    const isAnnotationState = !!(isAnnotationsLayer(layer) || isAnnotationsRealTime(layer));

    if (!isEmpty(pageBody) && !isEmpty(tableTitle) && !includes(BAD_URL, tableTitle[0])) {
      return (
        <>
          <Table
            responsive
            hover
            size="sm"
            className="text-truncate text-center"
            style={{ backgroundColor: 'white' }}
          >
            <thead>
              <tr>
                {tableTitle.map((cell, index) => (
                  <th
                    key={uuid()}
                    className="align-middle"
                    onClick={() => changeSortIndex(index)}
                    style={{ cursor: 'pointer' }}
                  >
                    {cell}
                    {isEqual(sortIndex.index, index) && (
                      <FontAwesomeIcon
                        icon={`sort-${sortIndex.order === DESCENDENT ? 'down' : 'up'}`}
                        className="ml-1"
                      />
                    )}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {pageBody.map(row => (
                <tr key={uuid()} onClick={() => {}}>
                  {row.map(cell => (
                    <td key={uuid()}>
                      {Array.isArray(cell) && isAnnotationState === true ? (
                        <div dangerouslySetInnerHTML={{ __html: getPopupAnnotations(cell) }} />
                      ) : (
                        <>
                          {verHtml ? <div dangerouslySetInnerHTML={{ __html: cell }} /> : `${cell}`}
                        </>
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
          <TablePagination
            totalCount={totalCount}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            changePage={this.changePage}
            isPaginationOn
          />
        </>
      );
    }
    if (includes(tableTitle, COMING_SOON)) {
      return (
        <BlankState
          icon={{ style: 'solid', symbol: 'cogs' }}
          title="This feature is not ready yet. Coming Soon"
          subtitle=""
        />
      );
    }
    return (
      <Alert variant="warning">{`No está disponible para este tipo de layer ${layerSubtype}`}</Alert>
    );
  }
}

ThematicLayerTable.defaultProps = {
  height: 0,
  verHtml: false,
  layer: {}
};

ThematicLayerTable.propTypes = {
  layer: PropTypes.object,
  height: PropTypes.number,
  loading: PropTypes.bool.isRequired,
  tableBody: PropTypes.array.isRequired,
  tableTitle: PropTypes.array.isRequired,
  layerSubtype: PropTypes.string.isRequired,
  isShared: PropTypes.bool.isRequired,
  changeSortIndex: PropTypes.func.isRequired,
  sortIndex: PropTypes.object.isRequired,
  verHtml: PropTypes.bool
};

export default ThematicLayerTable;
